import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import Modal from '../../components/Modal';
import { FAVORITE_CLICK_EVENT } from '../../webComponents/FavoriteIcon';
import Request from '../../utils/Request';
import Manipulator from '../../utils/dom/manipulator';
import { HIDE_MODAL_EVENT } from '../../webComponents/Modal/BasicModal';

const SELECTOR_PAGE = '.js-my-favourites';
const SELECTOR_RECENT_VENUE_LIST = '.js-recent-venues-grid';
const SELECTOR_FAVORITE_VENUE_LIST = '.js-favorite-venues-grid';
const SELECTOR_AFFILIATED_VENUE_LIST = '.js-affiliated-venues-grid';
const SELECTOR_CARD = '.lta-game-venue-card';
const SELECTOR_CARD_TITLE = '.venue-card-title';
const SELECTOR_CARD_ADDRESS = '.venue-card-address';
const SELECTOR_CARD_BUTTON = '.js-remove-venue';
const SELECTOR_MODAL = '#my-venue-remove-modal';
const SELECTOR_MODAL_REMOVE = '.js-modal-venue-remove';
const SELECTOR_MODAL_CANCEL = '.js-modal-venue-cancel';
const SELECTOR_MODAL_TITLE = '.venue-modal-title';
const SELECTOR_MODAL_ADDRESS = '.venue-modal-address';
const SELECTOR_MODAL_HEADING = '.venue-modal-dynamic-heading';
const SELECTOR_MODAL_UNFAVORITE = '#my-remove-favourite-venue-modal';
const SELECTOR_TOO_MANY_FAV_MODAL = '#lta-web-too-many-fav-modal';
const SELECTOR_MODAL_EXIT = '.js-exit-favourite-venue-modal';

const EVENT_CLICK = `click`;

class FavouriteVenue {
	constructor() {
		this._myContactId = undefined;
		this.removingCard = undefined;
		this._venueFavouriteCard = undefined;
		this.init();
	}

	set data(data) {
		this._data = data;
		this.render();
		this.bindEvents();
	}

	get data() {
		return this._data;
	}

	init() {
		this._wrapperElement = SelectorEngine.findOne(SELECTOR_PAGE);
		if (!this._wrapperElement) {
			return;
		}
		this._myContactId = this._wrapperElement.getAttribute('data-my-favourites-contact-id');
		this._removeVenue = SelectorEngine.findOne(SELECTOR_MODAL, this._wrapperElement);
		this._maxFavouriteVenuesAllowed = Manipulator.getDataAttribute(this._wrapperElement, 'max-favorite-vanues-allowed');
		this._removeVenueModalTitle = Manipulator.getDataAttribute(this._wrapperElement, 'remove-venue-modal-title');
		this._unfavouruiteVenueModalTitle = Manipulator.getDataAttribute(
			this._wrapperElement,
			'unfavourite-venue-modal-title'
		);
		this._recentVenuesList = SelectorEngine.findOne(SELECTOR_RECENT_VENUE_LIST, this._wrapperElement);
		this._removeFavoriteVenue = SelectorEngine.findOne(SELECTOR_MODAL_UNFAVORITE, this._wrapperElement);

		this._favoriteVenuesList = SelectorEngine.findOne(SELECTOR_FAVORITE_VENUE_LIST, this._wrapperElement);
		this._affiliatedVenuesList = SelectorEngine.findOne(SELECTOR_AFFILIATED_VENUE_LIST, this._wrapperElement);

		this.fetchVenuesByContactId();

		this._modalEl = SelectorEngine.findOne(SELECTOR_MODAL, this._wrapperElement);
		this._modelExitEl = SelectorEngine.findOne(SELECTOR_MODAL_EXIT, this._modalEl);
		this._modalInstance = new Modal(this._modalEl, {});

		EventHandler.on(this._modelExitEl, EVENT_CLICK, this.hideVenueModal.bind(this));

		if (this._modalInstance) {
			const _removeBtn = SelectorEngine.findOne(SELECTOR_MODAL_REMOVE, this._modalEl);
			const _cancelBtn = SelectorEngine.findOne(SELECTOR_MODAL_CANCEL, this._modalEl);

			EventHandler.on(_removeBtn, EVENT_CLICK, () => {
				if (this._isFavoriteRemoval) {
					this.removeVenueFromFavorites();
				} else {
					this.removeFavouriteVenue();
				}
			});

			EventHandler.on(_cancelBtn, EVENT_CLICK, this.hideVenueModal.bind(this));

			EventHandler.on(this._modalEl, 'hidden.lta.modal', () => {
				this.hideVenueModal();
			});
		}

		this.toggleHandlerBound = this.toggleHandler.bind(this);

		this._affiliatedVenuesList.addEventListener(FAVORITE_CLICK_EVENT, (event) => {
			const venue = this.data?.affiliatedVenues.find((venue) => `${venue.clubsparkId}` === event.target.id);
			this.toggleHandler(event, venue);
		});
		this._recentVenuesList.addEventListener(FAVORITE_CLICK_EVENT, (event) => {
			const venue = this.data?.recentVenues.find((venue) => `${venue.clubsparkId}` === event.target.id);
			this.toggleHandler(event, venue);
		});
		this._favoriteVenuesList.addEventListener(FAVORITE_CLICK_EVENT, (event) => {
			const venue = this.data?.favoriteVenues.find((venue) => `${venue.clubsparkId}` === event.target.id);
			this.toggleHandler(event, venue);
		});

		// TODO: Add logic for hiding modal
		this._tooManyFavModal = SelectorEngine.findOne(SELECTOR_TOO_MANY_FAV_MODAL, this._wrapperElement);
		if (this._tooManyFavModal) {
			this._tooManyFavModal.addEventListener(HIDE_MODAL_EVENT, (event) => {
				this.toggleTooManyFavouriteModal(false);
			});
		}
	}

	async removeFavouriteVenue() {
		const venueId = this.removingCard?.querySelector('[data-current-venue-id]')?.getAttribute('data-current-venue-id');

		const postData = {
			ContactId: this._myContactId,
			venue: [venueId]
		};
		const deleteVenue = await Request.post('/api/selfsubmission/deleteRecentVenue', postData).catch((e) => {
			console.log(e);
		});

		if (deleteVenue?.errors?.errorcode === '00') {
			this.hideVenueModal();
			this.fetchVenuesByContactId();
		}
	}

	async addVenueToFavorites(target, { venueId, venueName, imageUrl }) {
		const postData = { venueId, venueName, imageUrl };

		const response = await Request.put('/api/favorite/addfavoritevenue/', postData).catch((e) => {
			console.error(e);
		});

		if (response?.errors?.errorCode === '00') {
			target.setAttribute('is-favorite', 'true');
			this.hideVenueModal();
			this.fetchVenuesByContactId();
		}
	}

	async removeVenueFromFavorites() {
		const postData = {
			venueId: this._pendingUnfavoriteId
		};

		const response = await Request.delete('/api/favorite/removefavoritevenue/', postData).catch((e) => {
			console.error(e);
		});

		if (response?.errors?.errorCode === '00') {
			this._unfavoriteProcessingEl.setAttribute('is-favorite', 'false');
			this.hideVenueModal();
			this.fetchVenuesByContactId();
		}
	}

	bindEvents() {
		this._venueFavouriteCard = SelectorEngine.find(SELECTOR_CARD, this._wrapperElement);

		this._venueFavouriteCard.forEach((card) => {
			const _venueFavouriteCardButton = SelectorEngine.findOne(SELECTOR_CARD_BUTTON, card);
			EventHandler.on(_venueFavouriteCardButton, EVENT_CLICK, (event) => {
				this.showVenueModal(card, false); // recent venue modal
			});
		});
	}

	async toggleHandler(event, venue) {
		if(dataLayer) {
			const action = event.detail.isFavorite ? "added" : "removed";
			dataLayer.push({
				event: 'favourite_click',
				venue_id: venue.clubsparkId,
				venue_name: venue.name,
				favourite_status: action
			});
		}
		if (!venue) {
			console.log('No venue found');
			return;
		}
		const { clubsparkId: venueId, name: venueName, imageUrl } = venue;

		const target = event.target;
		const { isFavorite } = event.detail;

		// Prevent multiple clicks
		if (target.classList.contains('is-processing')) return;
		target.classList.add('is-processing');

		try {
			if (isFavorite) {
				// Add to favorites
				if (this._maxFavouriteVenuesAllowed <= (this.data?.favoriteVenues?.length)) {
					// Show modal if limit is reached
					this.toggleTooManyFavouriteModal(true);
					return;
				} else {
					// Safe to add to favorites
					await this.addVenueToFavorites(event.target, { venueId, venueName, imageUrl });
				}
			} else {
				// Remove from favorites
				this._pendingUnfavoriteId = venueId;
				this._unfavoriteProcessingEl = target;
				const card = target.closest('.lta-game-venue-card');
				this.showVenueModal(card, true); // favorite icon clicked
			}
		} catch (error) {
			console.error('API error:', error);
		} finally {
			// only reset if immediate add (not when showing modal)
			if (isFavorite) target.classList.remove('is-processing');
		}
	}

	toggleTooManyFavouriteModal(show = false) {
		if (this._tooManyFavModal) {
			this._tooManyFavModal.setAttribute('show', show);
		}
	}

	async fetchVenuesByContactId() {
		//try {
		// USE FOR PRODUCTION
		const result = await Request.get(
			`/api/selfsubmission/getRecentVenueByContactId?contactId=${this._myContactId}`
		).catch((error) => console.log(error));

		// USE FOR DEV
		// const result = await fetch(`http://dev-verolt.azurewebsites.net/api/selfsubmission/getRecentVenueByContactId?contactId=0038E00001KwMhnQAF`);
		const response = await result;

		if (response.errors.errorcode === '00') {
			this.data = response.response;
		}
		try {
			if (response.errors.errorcode == '01') {
				this.data = response.response;
			}
		} catch (error) {
			console.error(error);
		}

		// } catch (error) {
		// 	console.log(error);
		// }
	}

	showVenueModal(card, isFavoriteRemoval = false) {
		this.removingCard = card;
		this._isFavoriteRemoval = isFavoriteRemoval;

		const modalTitle = SelectorEngine.findOne(SELECTOR_MODAL_TITLE, this._modalEl);
		const modalAddress = SelectorEngine.findOne(SELECTOR_MODAL_ADDRESS, this._modalEl);
		const heading = SelectorEngine.findOne(SELECTOR_MODAL_HEADING, this._modalEl);

		const cardTitle = SelectorEngine.findOne(SELECTOR_CARD_TITLE, card);
		const cardAddress = SelectorEngine.findOne(SELECTOR_CARD_ADDRESS, card);

		modalTitle.innerHTML = cardTitle.innerHTML;

		if (isFavoriteRemoval) {
			// Find venue from favorites using clubsparkId (id on <lta-favorite-icon>)
			const favoriteIcon = card.querySelector('lta-favorite-icon');
			const clubsparkId = favoriteIcon?.getAttribute('id');

			const venue =
				this.data?.favoriteVenues.find((v) => `${v.clubsparkId}` === clubsparkId) ||
				this.data?.affiliatedVenues.find((v) => `${v.clubsparkId}` === clubsparkId) ||
				this.data?.recentVenues.find((v) => `${v.clubsparkId}` === clubsparkId);

			if (venue?.address) {
				const { street = '', city = '', state = '', postalcode = '' } = venue.address;
				modalAddress.innerHTML = `
					${street}<br/>
					${city}<br/>
					${state}<br/>
					${postalcode}
				`.trim();
			} else {
				modalAddress.innerHTML = 'Address not available';
			}
		} else {
			modalAddress.innerHTML = cardAddress.innerHTML.replace(',', '<br/>');
		}

		heading.textContent = isFavoriteRemoval ? this._unfavouruiteVenueModalTitle : this._removeVenueModalTitle;

		this._modalInstance.show();
	}

	hideVenueModal() {
		if (this._unfavoriteProcessingEl) {
			this._unfavoriteProcessingEl.classList.remove('is-processing');
			this._unfavoriteProcessingEl = null;
		}
		this.removingCard = null;
		this._isFavoriteRemoval = false;
		this._modalInstance.hide();
		this.bindEvents();
	}

	render() {
		this._affiliatedVenuesList.innerHTML = `
			<div class="l-lta-grid">
				${this.renderAffiliatedVenue(this.data.affiliatedVenues)}
			</div>
			<lta-carousel-v2 id="carousel-v2-wrapper-1" classes="md:u-hidden" slides-md="1" slides-xl="auto">
				${this.renderAffiliatedVenue(this.data.affiliatedVenues, true)}
			</lta-carousel-v2>`;
		this._recentVenuesList.innerHTML = `
			<div class="l-lta-grid">
				${this.renderRecentVenue(this.data.recentVenues)}				
			</div>
			<lta-carousel-v2 id="carousel-v2-wrapper-2" classes="md:u-hidden" slides-md="1" slides-xl="auto">
				${this.renderRecentVenue(this.data.recentVenues, true)}
			</lta-carousel-v2>`;
		this._favoriteVenuesList.innerHTML = `
			<div class="l-lta-grid">
				${this.renderFavoriteVenue(this.data.favoriteVenues)}
			</div>
			<lta-carousel-v2 id="carousel-v2-wrapper-3" classes="md:u-hidden" slides-md="1" slides-xl="auto">
				${this.renderFavoriteVenue(this.data.favoriteVenues, true)}
			</lta-carousel-v2>`;
	}

	renderRecentVenue(recentVenues, isSwiper = false) {
		const recentVenueCardRenderData = recentVenues
			.map((item) => {
				const rowItem = {};
				(rowItem.venueName = item.name),
					(rowItem.address = item.address),
					(rowItem.showButton = true),
					(rowItem.imageUrl = item.imageUrl),
					(rowItem.isFavorite = item.isFavorite),
					(rowItem.venueDetailPageUrl = item.venueDetailPageUrl),
					(rowItem.urlText = item.ctaButtonLabel),
					(rowItem.id = item.id),
					(rowItem.clubsparkId = item.clubsparkId);
				return this.renderVenueRow(rowItem, isSwiper);
			})
			.join('');
		return recentVenueCardRenderData;
	}

	renderAffiliatedVenue(affiliatedVenue, isSwiper = false) {
		const affiliatedVenueCardRenderData = affiliatedVenue
			.map((item) => {
				const rowItem = {};
				(rowItem.venueName = item.name),
					(rowItem.address = item.address),
					(rowItem.showButton = false),
					(rowItem.imageUrl = item.imageUrl),
					(rowItem.isFavorite = item.isFavorite),
					(rowItem.venueDetailPageUrl = item.venueDetailPageUrl),
					(rowItem.urlText = item.ctaButtonLabel),
					(rowItem.id = item.id),
					(rowItem.clubsparkId = item.clubsparkId);
				return this.renderVenueRow(rowItem, isSwiper);
			})
			.join('');
		return affiliatedVenueCardRenderData;
	}

	renderFavoriteVenue(favoriteVenue, isSwiper = false) {
		const favoriteVenueCardRenderData = favoriteVenue
			.map((item) => {
				const rowItem = {};
				(rowItem.venueName = item.name),
					(rowItem.address = item.address),
					(rowItem.showButton = false),
					(rowItem.imageUrl = item.imageUrl),
					(rowItem.isFavorite = item.isFavorite),
					(rowItem.venueDetailPageUrl = item.venueDetailPageUrl),
					(rowItem.urlText = item.ctaButtonLabel),
					(rowItem.id = item.id),
					(rowItem.clubsparkId = item.clubsparkId);
				return this.renderVenueRow(rowItem, isSwiper);
			})
			.join('');
		return favoriteVenueCardRenderData;
	}

	renderVenueRow(itemData, isSwiper = false) {
		let buttonHtml = itemData.showButton
			? `<button 
				type="button" 
				class="lta-btn lta-btn--md lta-btn--petite lta-btn--icon lta-btn--icon-before lta-card-edit-button lta-btn--xs js-remove-venue u-bg-white u-border-0 u-mt-2 u-p-1 u-caption2" 
				title="Remove">
					<svg class="lta-icon js-lta-text-input--btn-icon u-mr-0 " width="1.30em" height="1.30em" style="color:currentColor;" fill="currentColor" alt="close" aria-hidden="true">
						<use xlink:href="/static/images/icons/lta-icons.svg#close"></use>
					</svg>
				Remove
			</button>`
			: '';

		let gameVenueCard = `
			<div class="lta-card lta-game-venue-card u-mb-3 u-border-0">
				${buttonHtml}
				<input type="hidden" data-current-venue-id=${itemData?.id} />
				<a href=${itemData.venueDetailPageUrl}>
					<img
						class="venue-card-image lta-card-img-top lta- u-rounded"
						alt="Card image top"
						src=${itemData.imageUrl}
					/>
				</a>
				<div class="u-py-2">
					<div class="u-flex u-justify-space-between u-gap-2">
						<a class="text-decoration-none" href=${itemData.venueDetailPageUrl}>
							<p class="u-subtitle3 venue-card-title lta-card-text">${itemData?.venueName}
							</p>
						</a>
						<lta-favorite-icon 
							class="u-cursor-pointer js-fav-icon"
							is-favorite=${itemData.isFavorite}
							id="${itemData.clubsparkId}"
						>
						</lta-favorite-icon>
						
					</div>
					<p class="u-body2 venue-card-address lta-card-text u-mt-1">
						${itemData.address.city} ${itemData.address.postalcode}
					</p>
					<a class="lta-btn lta-btn--md lta-btn--link text-decoration-underline u-text-lta-blue u-body2 u-mt-2" href=${itemData?.venueDetailPageUrl}>
							${itemData?.urlText}
						</a>
					</div>
				</a>
			</div>
		`;

		return isSwiper
			? `<div class="swiper-slide">${gameVenueCard}</div>`
			: `<div class="sm:u-hidden md:u-block g-col-12 g-col-md-6 g-col-xl-4">${gameVenueCard}</div>`;
	}
}

const globalFavouriteVenue = new FavouriteVenue();
export default globalFavouriteVenue;
